import React, { useEffect, useRef, useState } from 'react'

const RecaptchaV2 = ({ sitekey, callback }) => {

    const recapctchaRef = useRef(null);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);

    const onRecaptchaLoad = () => {
        setIsRecaptchaLoaded(true);
    }

    useEffect(() => {
        window.onRecaptchaLoad = onRecaptchaLoad

        if (!window.grecaptcha) {
            const script = document.createElement("script")
            script.src = "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit"
            script.async = true
            script.defer = true
            document.head.appendChild(script)
        } else if (window.grecaptcha && window.grecaptcha.render) {
            setIsRecaptchaLoaded(true)
        }
        return () => {
            window.onRecaptchaLoad = null
        }
    }, []);

    useEffect(() => {
        if (isRecaptchaLoaded) {
            window.grecaptcha.render(recapctchaRef.current, {
                "sitekey": sitekey.toString(),
                "callback": callback,
            })
        }
    }, [isRecaptchaLoaded])
    return (
        <div ref={recapctchaRef} className='w-100 reCaptcha-Container'></div>
    )
}

export default RecaptchaV2
